<div pTooltip="No data points selected." showDelay="1000" hideDelay="500"
     [tooltipDisabled]="selectedDataPoints.length">
    <button pButton class="p-button-raised p-button-text cbms-button" (click)="showTagManagementDialog(selectedDataPoints)"
            [disabled]="!selectedDataPoints.length" pTooltip="Add / Delete tags to selected datapoints"
            showDelay="1000" hideDelay="500">
        <mat-icon svgIcon="tags"></mat-icon>
        Edit Tags
    </button>
</div>
